<template>
  <div class="certifications-bundle certifications-bundle-list" v-if="isBlackFridayActive">
    <div class="frame">
      <div class="text-wrapper">ADVENTURE 04</div>
      <div class="plans">
        <div class="frame-wrapper">
          <div class="div-wrapper">
            <div class="div">
              <div class="frame-wrapper-2">
                <div class="frame-wrapper-3">
                  <div class="div-2">
                    <div class="group">
                      <div class="discout-badge-wrapper">
                        <Discount50Badge />
                      </div>
                    </div>
                    <div class="div-5">
                      <div class="text-wrapper-4">50% OFF ALL INE SECURITY</div>
                      <div class="text-wrapper-5">Certifications</div>
                    </div>
                    <div class="certifications-bundle__discounts-apply">
                      Discounted prices are shown
                    </div>
                  </div>
                </div>
              </div>
              <div class="line" alt="Line"></div>
              <div class="frame-wrapper-4">
                <div class="frame-wrapper-5">
                  <div class="div-6">
                    <div class="div-7">
                      <div
                        class="voucher"
                        v-for="cert in availableCertifications"
                        :key="cert.id"
                        @click="updateSelectedCertification(cert)"
                      >
                        <div class="frame-wrapper-6">
                          <div class="frame-wrapper-7">
                            <div class="div-8">
                              <img class="image" :alt="cert.name" :src="cert.icon" />
                              <div class="div-9">
                                <div class="frame-wrapper-8">
                                  <div class="div-10">
                                    <div class="div-11">
                                      <div class="text-wrapper-6">{{ cert.name }}</div>
                                      <TooltipIcon
                                        class="tooltip-trigger"
                                        @click.stop="
                                          showModal({
                                            title: cert.name,
                                            content: cert.description,
                                            event: $event,
                                          })
                                        "
                                      />
                                    </div>
                                    <div class="text-wrapper-7">
                                      <span class="text-wrapper-7__interger-price"
                                        >${{ priceToShowWithoutCents(cert) }}</span
                                      >
                                      <span
                                        class="text-wrapper-7__interger-cents"
                                        v-if="priceToShowCents(cert)"
                                        >.{{ priceToShowCents(cert) }}</span
                                      >
                                    </div>
                                  </div>
                                </div>
                                <div class="shop-checkbox-instance">
                                  <CheckBox :isSelected="isSelected(cert)" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="!isAuthenticated" class="message">
                      <div class="ejpt-eeda-and-ewpt-wrapper">
                        <p class="ejpt-eeda-and-ewpt">
                          <span class="span"
                            >eJPT, eCPPT, eEDA, and eWPT only available with existing subscription.
                          </span>
                          <span class="text-wrapper-8" @click="handleOpenModal"
                            >Sign in to claim.</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PopupModal
      class="certifications-bundle__popup-modal"
      :style="{ top: modal.top, left: modal.left }"
      v-if="modalVisible"
      :title="modal.title"
      :content="modal.content"
      @close-modal="modalVisible = false"
    />
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { updateCart, utmParamsUtils } from '@/helpers/mixins'
import TooltipIcon from '@/assets/icons/tooltip_icon.svg'
import CheckBox from '@/components/shared/CheckBox.vue'
import PopupModal from '@/components/shared/PopupModal.vue'
import Discount50Badge from '@/assets/images/hero-section/black-friday/discount50-nobg.svg'

export default {
  name: 'CertificationsBundleList',
  mixins: [updateCart, utmParamsUtils],
  components: {
    Discount50Badge,
    TooltipIcon,
    PopupModal,
    CheckBox,
  },
  data() {
    return {
      modalVisible: false,
      modal: {
        title: '',
        content: '',
        top: '0px',
        left: '0px',
      },
    }
  },
  computed: {
    ...mapState({
      usersCurrentSubscriptions: state => state.subscriptions.usersCurrentSubscriptions,
      certifications: state => state.products.availableCertifications,
      shoppingCart: state => state.shoppingCart.shoppingCart,
      isAuthenticated: state => state.auth.isAuthenticated,
    }),
    ...mapGetters({
      isBlackFridayActive: 'app/isBlackFridayActive',
    }),
    userHasSubscription() {
      return this.usersCurrentSubscriptions.length > 0
    },
    availableCertifications() {
      return this.certifications.filter(cert => cert.user_receives_discount)
    },
  },
  methods: {
    ...mapMutations({
      setIsSignInModalShown: 'app/IS_SIGN_IN_MODAL_SHOWN_UPDATED',
    }),
    handleOpenModal() {
      this.setIsSignInModalShown(true)
    },
    priceToShowWithoutCents(cert) {
      // return the integer part of discounted_price_cents without the cents
      return cert.discounted_price_cents.toString().slice(0, -2)
    },
    priceToShowCents(cert) {
      // return the cents part of discounted_price_cents if it's not 0, if it's 00 return null
      const cents = cert.discounted_price_cents.toString().slice(-2)
      return cents === '00' ? null : cents
    },
    isSelected(cert) {
      return !!this.shoppingCart.find(item => item.merchant_id === cert.merchant_id)
    },
    updateSelectedCertification(cert) {
      const exists = this.shoppingCart.find(item => item.id === cert.id)
      if (exists) {
        this.removeProductFromShoppingCart(cert)
      } else {
        this.addProductToCart(cert)
      }
    },
    showModal({ title, content, event }) {
      this.modalVisible = true
      this.modal.title = title
      this.modal.content = content
      const modalWidth = 432

      const parentPos = this.$el.getBoundingClientRect()
      const childPos = event.target.getBoundingClientRect()

      this.modal.top = `${childPos.top - parentPos.top}px`

      // if the modal is too close to the right edge of the parent border, move it to the left
      if (childPos.left - parentPos.left + childPos.width + modalWidth > parentPos.width) {
        this.modal.left = `${childPos.left - parentPos.left - modalWidth}px`
      } else {
        this.modal.left = `${childPos.left - parentPos.left + childPos.width}px`
      }

      // if the modal left is out of the screen set it to 0
      if (parseInt(this.modal.left) < 0) {
        this.modal.left = '0px'
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.certifications-bundle {
  --body-III-font-family: 'CircularStd-Book', Helvetica;
  --body-III-font-size: 12px;
  --body-III-font-style: normal;
  --body-III-font-weight: 400;
  --body-III-letter-spacing: 0px;
  --body-III-line-height: 14px;
  --businessdarker-gray: rgba(87, 87, 92, 1);
  --h3-bold-font-family: 'CircularStd-Bold', Helvetica;
  --h3-bold-font-size: 32px;
  --h3-bold-font-style: normal;
  --h3-bold-font-weight: 700;
  --h3-bold-letter-spacing: 0px;
  --h3-bold-line-height: 38px;
  --h4-bold-font-family: 'CircularStd-Bold', Helvetica;
  --h4-bold-font-size: 24px;
  --h4-bold-font-style: normal;
  --h4-bold-font-weight: 700;
  --h4-bold-letter-spacing: 0px;
  --h4-bold-line-height: 32px;
  --primaryine-white: rgba(255, 255, 255, 1);
  --secondarylight-blue-gray: rgba(175, 176, 191, 1);
  --secondarypurple-pale: rgba(201, 187, 255, 1);
  --small: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
  --subtitles-font-family: 'CircularStd-Medium', Helvetica;
  --subtitles-font-size: 18px;
  --subtitles-font-style: normal;
  --subtitles-font-weight: 500;
  --subtitles-letter-spacing: 0px;
  --subtitles-line-height: 24px;

  position: relative;

  &__discounts-apply {
    color: var(--light-blue-gray, #afb0bf);
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 450;
    line-height: 20px; /* 142.857% */
  }
  .frame {
    background: linear-gradient(105deg, rgba(62, 63, 73, 0.7) 0%, rgba(62, 63, 73, 0) 100%);
    backdrop-filter: blur(30px);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    align-self: stretch;
    overflow: hidden;
    position: relative;
    @include desktop {
      align-items: center;
    }
  }

  .frame .plans {
    display: flex;
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    @include desktop {
      align-items: flex-start;
      border-radius: 20px;
      display: flex;
      flex: 1;
      flex-grow: 1;
      padding: 40px;
      position: relative;
    }
  }

  .frame .frame-wrapper {
    align-items: flex-start;
    border-radius: 10px 10px 0px 0px;
    position: relative;
    width: 100%;
    @include tablet {
      display: flex;
      flex: 1;
      flex-grow: 1;
      gap: 35px;
    }
  }

  .frame .div-wrapper {
    align-items: flex-start;
    display: flex;
    flex: 1;
    flex-grow: 1;
    position: relative;
  }

  .frame .div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    align-self: stretch;
    width: 100%;
    @include desktop {
      align-items: flex-start;
      flex-direction: row;
      flex: 1;
      flex-grow: 1;
      gap: 40px;
      position: relative;
    }
  }

  .frame .frame-wrapper-2 {
    align-items: center;
    align-self: stretch;
    display: flex;
    gap: 10px;
    justify-content: center;
    position: relative;
    @include desktop {
      width: 284px;
    }
  }

  .frame .frame-wrapper-3 {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 60px;
    justify-content: center;
    position: relative;
    width: 200px;
  }

  .frame .div-2 {
    align-items: center;
    align-self: stretch;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    gap: 20px;
    justify-content: center;
    position: relative;
    width: 100%;
    @include tablet {
      gap: 40px;
    }
  }

  .frame .group {
    .discout-badge-wrapper {
      width: 217px;
      height: 155px;
    }
  }

  .frame .overlap-group {
    height: 201px;
    left: 0;
    position: relative;
    top: 0;
    width: 200px;
  }

  .frame .div-3 {
    align-items: center;
    display: inline-flex;
    flex-direction: column;
    height: 87px;
    justify-content: center;
    left: 46px;
    position: absolute;
    top: 57px;
  }

  .frame .text-wrapper {
    left: 0;
    top: 0;
    position: absolute;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--orange-gradient);
    width: 111px;
    height: 28px;
    padding: 7px;
    border-radius: 7px 0px 0px 0px;
    font-size: 12px;
    font-weight: 700;
  }

  .frame .text-wrapper-2 {
    color: var(--primaryine-white);
    font-family: 'Circular Std-Bold', Helvetica;
    font-size: 54px;
    font-weight: 700;
    letter-spacing: 0;
    line-height: 66px;
    margin-top: -1px;
    position: relative;
    white-space: nowrap;
    width: fit-content;
  }

  .frame .text-wrapper-3 {
    color: var(--primaryine-white);
    font-family: 'Circular Std-Black', Helvetica;
    font-size: 24px;
    font-weight: 900;
    letter-spacing: 0;
    line-height: 30px;
    margin-top: -11px;
    position: relative;
    text-align: center;
    white-space: nowrap;
    width: fit-content;
  }

  .frame .div-5 {
    align-items: flex-start;
    display: inline-flex;
    flex: 0 0 auto;
    flex-direction: column;
    justify-content: center;
    position: relative;
    margin-top: 20px;
    @include tablet {
      margin-top: 0;
    }
  }

  .frame .text-wrapper-4 {
    align-self: stretch;
    color: var(--secondarypurple-pale);
    font-family: var(--body-III-font-family);
    font-size: var(--body-III-font-size);
    font-style: var(--body-III-font-style);
    font-weight: var(--body-III-font-weight);
    letter-spacing: var(--body-III-letter-spacing);
    line-height: var(--body-III-line-height);
    margin-top: -1px;
    position: relative;
    text-align: center;
  }

  .frame .text-wrapper-5 {
    color: var(--primaryine-white);
    font-family: var(--h4-bold-font-family);
    font-size: var(--h4-bold-font-size);
    font-style: var(--h4-bold-font-style);
    font-weight: var(--h4-bold-font-weight);
    letter-spacing: var(--h4-bold-letter-spacing);
    line-height: var(--h4-bold-line-height);
    position: relative;
    white-space: nowrap;
    width: fit-content;
  }

  .frame .line {
    @include desktop {
      align-self: stretch;
      object-fit: cover;
      position: relative;
      width: 1px;
      height: 100%;
      transform: rotate(180deg);
      background: linear-gradient(
        112deg,
        rgba(187, 188, 199, 0.4) -46.39%,
        rgba(187, 188, 199, 0) 112.38%
      );
    }
  }

  .frame .frame-wrapper-4 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 25px;
    align-self: stretch;
    position: relative;
    @include desktop {
      align-items: center;
      flex: 1;
      flex-grow: 1;
      gap: 30px;
    }
  }

  .frame .frame-wrapper-5 {
    align-items: center;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    gap: 20px;
    margin-left: -0.5px;
    margin-right: -0.5px;
    position: relative;
    width: 100%;
    @include desktop {
      max-width: 675px;
    }
  }

  .frame .div-6 {
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    gap: 25px;
    position: relative;
    width: 100%;
  }

  .frame .div-7 {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 25px;
    align-self: stretch;
    @include mobile {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 25px;
    }
  }

  .frame .message {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 15px;
    flex: 1 0 0;
    width: 100%;
    @include desktop {
      padding: 0px 20px;
    }
  }

  .frame .voucher {
    display: flex;
    height: 79px;
    padding: 0px 20px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 15px;
    align-self: stretch;
    background: var(
      --glass-mid-gray,
      linear-gradient(105deg, rgba(62, 63, 73, 0.7) -13.91%, rgba(62, 63, 73, 0) 100.48%)
    );
    border-radius: 10px;
    position: relative;
    transition: all 1s ease-out;
    &:hover {
      background: var(--mid-gray-translucid-gradient);
      cursor: pointer;
    }
    @include desktop {
      align-items: center;
      flex: 1;
      flex-direction: column;
      flex-grow: 1;
      gap: 15px;
      height: 79px;
      justify-content: center;
    }
  }

  .frame .frame-wrapper-6 {
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    flex: 0 0 auto;
    gap: 35px;
    justify-content: flex-end;
    margin-bottom: -13.18px;
    margin-top: -13.18px;
    position: relative;
    width: 100%;
  }

  .frame .frame-wrapper-7 {
    align-items: flex-end;
    align-self: stretch;
    display: flex;
    flex: 1;
    flex-direction: column;
    flex-grow: 1;
    gap: 20px;
    justify-content: center;
    position: relative;
  }

  .frame .div-8 {
    align-items: center;
    align-self: stretch;
    display: flex;
    flex: 0 0 auto;
    gap: 20px;
    position: relative;
    width: 100%;
  }

  .frame .image {
    height: 105.35px;
    object-fit: cover;
    position: relative;
    width: 80px;
  }

  .frame .div-9 {
    align-items: center;
    display: flex;
    flex: 1;
    flex-grow: 1;
    gap: 20px;
    justify-content: flex-end;
    position: relative;
  }

  .frame .frame-wrapper-8 {
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    flex: 1;
    flex-direction: column;
    flex-grow: 1;
    position: relative;
  }

  .frame .div-10 {
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    justify-content: center;
    position: relative;
    width: 100%;
  }

  .frame .div-11 {
    align-items: center;
    align-self: stretch;
    display: flex;
    flex: 0 0 auto;
    gap: 5px;
    position: relative;
    width: 100%;
  }

  .frame .text-wrapper-6 {
    color: #ffffff;
    font-family: var(--subtitles-font-family);
    font-size: var(--subtitles-font-size);
    font-style: var(--subtitles-font-style);
    font-weight: var(--subtitles-font-weight);
    letter-spacing: var(--subtitles-letter-spacing);
    line-height: var(--subtitles-line-height);
    position: relative;
    white-space: nowrap;
    width: fit-content;
  }

  .frame .tooltip-trigger {
    position: relative !important;
    width: 16px !important;
    &:hover {
      cursor: pointer;
    }
  }

  .frame .text-wrapper-7 {
    color: var(--primaryine-white);
    font-family: var(--h3-bold-font-family);
    font-size: var(--h3-bold-font-size);
    font-style: var(--h3-bold-font-style);
    font-weight: var(--h3-bold-font-weight);
    letter-spacing: var(--h3-bold-letter-spacing);
    position: relative;
    text-align: right;
    white-space: nowrap;
    width: fit-content;
    max-height: 38px;
    &__interger-cents {
      vertical-align: super;
      font-size: 20px;
    }
  }

  .frame .shop-checkbox-instance {
    left: unset !important;
    top: unset !important;
  }

  .frame .ejpt-eeda-and-ewpt-wrapper {
    align-items: center;
    border-radius: 10px;
    display: flex;
    flex: 1;
    flex-direction: column;
    flex-grow: 1;
    gap: 15px;
    justify-content: center;
    position: relative;
    @include desktop {
      padding: 0px 20px;
    }
  }

  .frame .ejpt-eeda-and-ewpt {
    align-self: stretch;
    color: transparent;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 20px;
    margin-top: -1px;
    position: relative;
    text-align: center;
  }

  .frame .span {
    color: #aeb0bf;
  }

  .frame .text-wrapper-8 {
    color: var(--melrose);
    &:hover {
      cursor: pointer;
      color: var(--purple-pale);
    }
  }
}
</style>
